import { Injector } from '@angular/core';
import { AsyncSubject } from 'rxjs';

export class AppInjector {
  private static injector: Injector = undefined;
  private static subject = new AsyncSubject<Injector>();
  static setInjector(injector: Injector) {
    AppInjector.injector = injector;
    AppInjector.subject.next(AppInjector.injector);
    AppInjector.subject.complete();
  }
  static getInjector(): AsyncSubject<Injector> {
    return AppInjector.subject;
  }
}

